import axios from 'axios';
import { isBrowser } from '../../server/helpers/browserDetector';

// ##### 25-03-06 Komarov: Фунция для запроса к Серверу Сайта сохранения данных в файл. Передаёт Серверу данные, необходимые для того, чтобы Сервер Сайта отправил соотв. запрос Смарту (повторил со своей стороны запрос Клиента к Смарту и сохранил данные ответа). Служит для того, чтобы при запросе данных у Смарта ещё и сохранить ответ в файл, как резервную копию для чтения из неё в случае ошибки ответа от Смарта. На стороне Сервера Сайта если requestType === 'POST', то url для запроса к Смарту берётся из postObject.url, а если requestType === 'GET', - то - из smartUrl
// ##### Komarov 2025-07-03
/* const saveLoadedData = async ({
  smartUrl,
  actionType,
  requestType,
  postObject,
  data,
}) => {
  // ##### 25-05-10 Komarov: исключаем из сохранения данные с ценами (динамические данные)
  if (
    [
      "GET_HOTEL_RATES_RES2",
      "GET_HOTEL_RATES_RES4",
      "RESET_HOTEL_RATES",
    ].includes(actionType)
  ) {
    return;
  }
  const url = `${process.env.REACT_APP_URL}/saveLoadedData`;
  await axios.post(
    url,
    {
      smartUrl,
      actionType,
      requestType,
      postObject,
      data,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
}; */

// ##### 25-03-06 Komarov: Фунция для запроса на чтение данных из файла в случае ошибки ответа от Смарта. Функция посылает запрос Серверу Сайта на чтение данных из соотв. файла, который, возможно, сохранён раньше. Параметр func - ссылка на функцию, которая диспатчит action с типом, означающим запись данных успешного ответа в Redux (например, тип action GET_TOPHOTELS_RES).
export const readData = async ({
  smartUrl,
  actionType,
  postObject,
  dispatch,
}) => {
  const url = `${process.env.REACT_APP_URL}readData`;
  await axios
    .post(
      url,
      {
        smartUrl,
        actionType,
        postObject,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then(async res => {
      // ##### 25-03-28 Komarov
      dispatch({
        type: actionType,
        payload: await res.data.data,
      });
    });
};

// ##### 25-03-28 Komarov
export const getSavingDataClient = async ({
  smartUrl,
  typeRes,
  typeErr,
  dispatch,
  processDataFunction, // ##### 25-03-28 Komarov: функция обработки полученного ответа от Смарта (не обязательная, если нужно), создаётся в соотв. action (если нужно записать в Redux не просто ответ, а объект с дополнительными полями, в одном из которых будет ответ от Смарта)
  isSpecialCondition, // ##### 25-03-28 Komarov: функция проверки ополнительного условия (не обязательная, если нужно), создаётся в соотв. action
}) => {
  // ##### 25-04-11 Komarov: запрашиваем у Сервера Сайта сохранение данных для запроса с текущими параметрами
  /* await saveData({
    smartUrl,
    actionType: typeRes,
    requestType: "GET",
  }); */

  try {
    // ##### 26-07-07: CORS fix — browser calls SSR proxy instead of Smart API directly
    // ##### 26-07-29 Komarov: Fix SSL certificate verification error on the server side
    const response = isBrowser
      ? await axios.post(`${process.env.REACT_APP_URL}api/smart-proxy`, { url: smartUrl, method: 'GET' })
      : await axios.get(smartUrl, { httpsAgent: new (require('https').Agent)({ rejectUnauthorized: false }) });

    if (response.data === 'Are you lost?') {
      throw new Error("Smart's response: Are you lost?");
    }
    if (
      typeof isSpecialCondition === 'function' &&
      !isSpecialCondition(response.data)
    ) {
      return false;
    }
    const data = processDataFunction
      ? await processDataFunction(response.data)
      : response.data;
    dispatch({ type: typeRes, payload: data });
  } catch (err) {
    await readData({ smartUrl, actionType: typeRes, dispatch });
    dispatch({ type: typeErr, error: err });
  }
};

// ##### 25-03-28 Komarov
export const postSavingDataClient = async ({
  postObject,
  typeRes,
  typeErr,
  dispatch,
  processDataFunction, // ##### 25-03-28 Komarov: функция обработки полученного ответа от Смарта (не обязательная, если нужно), создаётся в соотв. action (если нужно записать в Redux не просто ответ, а объект с дополнительными полями, в одном из которых будет ответ от Смарта)
  isSpecialCondition, // ##### 25-03-28 Komarov: функция проверки ополнительного условия (не обязательная, если нужно), создаётся в соотв. action
}) => {
  // ##### 25-04-11 Komarov: запрашиваем у Сервера Сайта сохранение данных для запроса с текущими параметрами
  /* await saveData({
    actionType: typeRes,
    requestType: "POST",
    postObject,
  }); */

  try {
    // ##### 26-07-07: CORS fix — browser calls SSR proxy instead of Smart API directly
    // ##### 26-07-29 Komarov: Fix SSL certificate verification error on the server side
    const response = isBrowser
      ? await axios.post(`${process.env.REACT_APP_URL}api/smart-proxy`, { url: postObject.url, method: 'POST', data: postObject.parameters })
      : await axios.post(postObject.url, postObject.parameters, { httpsAgent: new (require('https').Agent)({ rejectUnauthorized: false }) });

    if (response.data === 'Are you lost?') {
      throw new Error("Smart's response: Are you lost?");
    }
    if (
      typeof isSpecialCondition === 'function' &&
      !isSpecialCondition(response.data)
    ) {
      return false;
    }
    const data = processDataFunction
      ? await processDataFunction(response.data)
      : response.data;
    dispatch({ type: typeRes, payload: data });
  } catch (err) {
    await readData({ smartUrl: postObject.url, actionType: typeRes, dispatch });
    dispatch({ type: typeErr, error: err });
  }
};
